import { Link } from 'react-router-dom';
import BrandLogo from '../BrandLogo';

const NAV_ITEMS = [
  {
    id: 'drivers',
    to: '/admin',
    title: 'Driver applications',
    hint: 'Review documents and approve drivers',
    icon: '👤',
    tone: 'drivers',
  },
  {
    id: 'instant',
    to: '/admin/instant-rides',
    title: 'Instant ride',
    hint: 'Live city trips from the rider app',
    icon: '⚡',
    tone: 'instant',
  },
  {
    id: 'hire',
    to: '/admin/hire-rides',
    title: 'Hire a car',
    hint: 'Outstation and website bookings',
    icon: '🚗',
    tone: 'hire',
  },
  {
    id: 'referrals',
    to: '/admin/referrals',
    title: 'Referrals',
    hint: 'Who referred whom — bonus counts',
    icon: '🤝',
    tone: 'referrals',
  },
  {
    id: 'ratings',
    to: '/admin/ratings',
    title: 'Driver ratings',
    hint: 'Rider stars, feedback, and follow-up',
    icon: '⭐',
    tone: 'ratings',
  },
];

function AdminShell({ userEmail, active = 'drivers', onLogout, children, actions = null }) {
  return (
    <div className="admin-app">
      <header className="admin-topbar">
        <div className="admin-topbar__brand">
          <BrandLogo size="sm" />
          <div>
            <strong>Saarthi Admin</strong>
            <p className="admin-topbar__tagline">Manage drivers and customer trips</p>
            <p className="admin-topbar__user">{userEmail}</p>
          </div>
        </div>
        <div className="admin-topbar__actions">
          {actions}
          <Link to="/" className="btn btn--ghost-dark">
            Public website
          </Link>
          <button type="button" className="btn btn--primary" onClick={onLogout}>
            Log out
          </button>
        </div>
      </header>

      <nav className="admin-nav" aria-label="Admin sections">
        <div className="admin-nav__inner">
          {NAV_ITEMS.map((item) => {
            const isActive = active === item.id;
            return (
              <Link
                key={item.id}
                to={item.to}
                className={`admin-nav__item admin-nav__item--${item.tone} ${
                  isActive ? 'admin-nav__item--active' : ''
                }`}
                aria-current={isActive ? 'page' : undefined}
              >
                <span className="admin-nav__icon" aria-hidden="true">
                  {item.icon}
                </span>
                <span className="admin-nav__text">
                  <span className="admin-nav__title">{item.title}</span>
                  <span className="admin-nav__hint">{item.hint}</span>
                </span>
              </Link>
            );
          })}
        </div>
      </nav>

      <main className="admin-main">{children}</main>
    </div>
  );
}

export default AdminShell;
